import { US_STATES } from 'constants/states';

export const labelFor = (options, value) => options.find((o) => o.value === value)?.label ?? '';

export const labelsFor = (options, values = []) =>
  values.map((v) => labelFor(options, v) || v).join(', ');

export const stateNames = (abbrs = []) =>
  abbrs.map((abbr) => US_STATES.find((s) => s.abbr === abbr)?.name || abbr).join(', ');

// Date-only fields (YYYY-MM-DD) are split rather than parsed, so they never shift a
// day in browsers west of UTC.
export const formatDate = (isoDate) => {
  if (!isoDate) return '';
  const [year, month, day] = String(isoDate).slice(0, 10).split('-');
  return `${month}/${day}/${year}`;
};

export const formatDateTime = (isoDateTime) =>
  isoDateTime
    ? new Date(isoDateTime).toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      })
    : '';

export const formatNumber = (n) => (n === null || n === undefined || n === '' ? '' : Number(n).toLocaleString());

export const formatPercent = (rate) => (rate === null || rate === undefined ? '' : `${(rate * 100).toFixed(1)}%`);

export const orDash = (value) => (value === null || value === undefined || value === '' ? '—' : value);
